export default "__VITE_ASSET__bKqw6uYZ__"